export const brandFunnelStagesEndPoint = `brand-funnel-stages/funnel-analyzer`;
export const questionnaireEndPoint = 'questionnaire';
